export const QUERY_PARAMS_OUTPUT = {
  ACCESS_TOKEN: 't',
  REGISTER: 'register',
}
